<template>
    <div v-if="showDom" class="famous-pc-comment-list-form" v-bind:class="className">
        <div v-if="commentTotalReplyData[contentKey]" class="famous-pc-comment-list">
            <div v-if="commentTotalReplyData[contentKey] && commentTotalReplyData[contentKey].length > 0">
                <famous-comment-item-web
                    v-for="data in commentTotalReplyData[contentKey].slice(0, 2)"
                    v-bind:key="data.key+data.id"
                    v-bind:itemData="data"
                    v-bind:itemFunc="clickCheckAll"
                    v-bind:operateFunc="clickCommentOperate">
                </famous-comment-item-web>
            </div>
            <div v-if="commentTotalReplyData[contentKey] && commentTotalReplyData[contentKey].length > 2" class="famous-pc-comment-more" @click="clickCheckAll">查看全部{{commentTotalReplyData[contentKey].length}}条评论</div>
        </div>
    </div>
</template>

<script>
import FamousCommentItemWeb from '../../components/famouspedia/FamousCommentItemWeb.vue'
import { FAMOUS_DOM } from '../../modules/dom'
import { UA } from '../../modules/utils'
export default {
    name: 'FamousCommentListFormWeb',
    components: { FamousCommentItemWeb },
    props: {
        className: {
            type: String,
            default() { return '' }
        },
        liunianTitle: {
            type: String,
            default() { return '' }
        },
        contentKey: {
            type: String,
            default() { return '' }
        }
    },
    computed: {
        commentTotalReplyData() {
            return this.$store.state.famouspediacomment.commentTotalReplyData;
        }
    },
    data() {
        return{
            defaultAvatar: require('../../assets/images/avatar.png'),
            showDom: true
        }
    },
    created() {
        var userInfo = this.$store.state.userData;
        if(userInfo && userInfo.info && userInfo.info.avatar) {
            this.defaultAvatar = userInfo.info.avatar;
        }
    },
    mounted() {
        this.$bus.on('updateCommentListForm', this.updateDom)
    },
    destroyed() {
        this.$bus.off('updateCommentListForm', this.updateDom)
    },
    methods: {
        updateDom() {
            this.showDom = false;
            var me = this;
            setTimeout(() => {
                me.showDom = true;                
            }, 10);
        },
        clickCheckAll() {
            console.log('clickCheckAll------', this.contentKey)
            var me = this,
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: this.contentKey,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                key: this.contentKey,
                cb: function() {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormStyle();
                        FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        window.scrollTo(0, 0);
                        // 设置迷你命盘数据
                        var itemId = me.$store.state.famouspediacomment.commentAllYear;
                        me.$bus.emit('triggerTitleLinkItem', itemId)
                    }, 20);
                }
            });
        },
        clickCommentOperate(opType, commentData) {
            var me = this,
                baikeId = this.$store.state.famouspedia.curPediaBaziId;
            console.log('clickCommentOperate-----', opType, commentData)
            switch(opType) {
                case 'like':
                    this.$store.dispatch('famouspediacomment/toggleLikeComment', {
                        from: 'list',
                        baikeId: baikeId,
                        data: commentData
                    });
                    break;
                case 'reply':
                    this.$store.dispatch('famouspediacomment/setCommentFormData', {
                        formData: {
                            bid: baikeId,
                            f_type: commentData.key,
                            parentsid: commentData.parentsid == 0 ? commentData.id : commentData.parentsid,
                            touid: commentData.uid
                        },
                        cb: function() {
                            setTimeout(() => {
                                if(!UA.isIphone()) {
                                    FAMOUS_DOM.focusBottomBarTextArea();
                                }
                            }, 20);
                        }
                    });

                    this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                        key: commentData.key,
                        cb: function() {
                            setTimeout(() => {
                                FAMOUS_DOM.updateFamousFormStyle();
                                FAMOUS_DOM.bindFamousFormScrollEvent(false);
                                me.$bus.emit('focusFamousBottomBar');
                                window.scrollTo(0, 0);
                                me.$store.state.famouspediacomment.commentTextAreaToName = commentData.userName;

                                // 设置迷你命盘数据
                                var itemId = me.$store.state.famouspediacomment.commentAllYear;
                                me.$bus.emit('triggerTitleLinkItem', itemId)
                            }, 20);
                        }
                    });
                    break;
                default:
                    break;
            }
        }
    }
}
</script>